export default "__VITE_ASSET__MRJU6W1H__"